import * as z from "zod";

export const nicknameSchema = z.object({
	nickname: z
		.string()
		.min(5, { message: "O apelido deve ter pelo menos 5 caracteres." })
		.trim(),
});

export type NicknameFormValues = z.infer<typeof nicknameSchema>;

export const changePasswordSchema = z
	.object({
		oldPassword: z.string().min(1, { message: "Informe a senha atual." }),
		newPassword: z
			.string()
			.min(8, { message: "A nova senha deve ter pelo menos 8 caracteres." }),
		confirmPassword: z.string().min(1, { message: "Confirme a nova senha." }),
	})
	.refine((data) => data.newPassword === data.confirmPassword, {
		message: "As senhas não coincidem.",
		path: ["confirmPassword"],
	});

export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;
